import { AngularServices, getAngularService, } from '../../core/helpers/get-angular-service';
import { useState, useEffect } from 'react';
import { ExtensionsEventsEnum } from '../../extensions-framework/sdk.types';
export const useIsWhiteboardOpen = () => {
    const globalUi = getAngularService(AngularServices.GlobalUi);
    const [isOpen, setOpen] = useState(Boolean(globalUi.ui.isShowingWhiteboard));
    useEffect(() => {
        const $rootScope = getAngularService(AngularServices.RootScope);
        const handler = (_e, value) => {
            setOpen(value);
        };
        const unsubscribe = $rootScope.$on(ExtensionsEventsEnum.IS_SHOWING_WHITEBOARD, handler);
        return () => {
            unsubscribe();
        };
    }, []);
    return isOpen;
};
